import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { DateOnlyFormat, formatDateOnlyString, isDateOnlyString } from '../../../utils/date.utils';

/**
 *
 * 20/03/2024
 * 2024-03-20
 * 08.05.2024
 * Jul 05, 2024
 * Jun 11, 2024, 14:00
 *
 */

type FormatType =
  | 'dd/MM/yyyy'
  | 'yyyy-MM-dd'
  | 'dd.MM.yyyy'
  | 'MMM dd, yyyy'
  | 'MMM dd, y, HH:mm'
  | 'MMM dd, yyyy, HH:mm';

const RAW_TEXT_FORMATS = new Set<DateOnlyFormat>(['dd/MM/yyyy', 'yyyy-MM-dd', 'dd.MM.yyyy', 'MMM dd, yyyy']);

function isRawTextFormat(formatType: FormatType): formatType is DateOnlyFormat {
  return RAW_TEXT_FORMATS.has(formatType as DateOnlyFormat);
}

@Component({
  selector: 'app-date',
  imports: [DatePipe],
  templateUrl: './date.component.html',
})
export class DateComponent {
  @Input() date: Date | string;
  @Input() formatType: FormatType;

  get rawTextValue(): string | null {
    if (typeof this.date !== 'string' || !isDateOnlyString(this.date) || !isRawTextFormat(this.formatType)) {
      return null;
    }

    return formatDateOnlyString(this.date, this.formatType);
  }
}
